let module = {
  /**
     * 获取涨跌幅保留位数
     * @param {string} key 
     */
  getScale(key) {
    // 开通中登后不做位数处理
    let zdlegal = true
    if (zdlegal && (key === 'pernetvalue' || key === 'totalnetvalue')) {
      return -1;
    }
    // 七日年化、万份收益、单位净值、累计净值
    if (key == 'hfincomeratio' || key === 'pernetvalue' || key === 'totalnetvalue' || key === 'incomeratio') {
      return 4;
    }
    return 2;
  },
  getDayinc(val) {
    let dayincMul100 = false
    if (dayincMul100) {
      var valParsed = parseFloat(val);
      if (false == isNaN(valParsed)) {
        valParsed *= 100;
        return valParsed
      } else {
        return val;
      }
    } else {
      return val
    }
  },
  /**
   * 获取涨跌幅颜色
   * @param {String|Number} value 原值
   * @param {Boolean} cansee 是否可见
   */
  getIncomeColor(value, cansee = true) {
    let fincome = parseFloat(value);
    if (!cansee || isNaN(fincome) || fincome == 0) return 'm-color-6'; // 不可见，非数字或0
    return fincome > 0 ? 'up-color' : 'down-color';
  },
  /**
   * 获取涨跌幅单位
   */
  getIncomeUnit(key) {
    // 万份收益、单位净值、累计净值
    if (key == 'hfincomeratio' || key === 'pernetvalue' || key === 'totalnetvalue') {
      return '';
    }
    return '%';
  }
}

export default module;